import './campaign-links'
import { initializeLatestRelease } from './release'

void initializeLatestRelease()
